import { combineReducers } from 'redux';

import { uniq } from 'lodash';
import * as types from '../types';

const byId = (state = {}, action) => {
  switch (action.type) {
    //TYPES COMPLETED FETCH, ADD AND EDIT
    case types.ETAMONITORING_DESTINATIONS_FETCH_COMPLETED: {
      const { entities, order } = action.payload;
      const newState = { ...state };
      console.log('entities', entities);
      console.log('order', order);
      order.forEach((destinationId) => {
        newState[destinationId] = {
          isSelected: false,
          ...state[destinationId],
          ...entities[destinationId],
          isConfirmed: true
        };
      });
      return newState;
    }
    //DEFAULT
    default: {
      return state;
    }
  }
};

const order = (state = [], action) => {
  switch (action.type) {
    //CASE COMPLETED FETCH, ADD AND REMOVE
    case types.ETAMONITORING_DESTINATIONS_FETCH_COMPLETED: {
      const { order } = action.payload;
      return uniq([...state, ...order]);
    }
    //DEFAULT
    default: {
      return state;
    }
  }
};

const isFetchingList = (state = false, action) => {
  switch (action.type) {
    case types.ETAMONITORING_DESTINATIONS_FETCH_STARTED: {
      return true;
    }
    case types.ETAMONITORING_DESTINATIONS_FETCH_COMPLETED:
    case types.ETAMONITORING_DESTINATIONS_FETCH_FAILED: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const etaModels = combineReducers({
  byId,
  order,
  isFetchingList
  //configurations
});

export default etaModels;

//Own state
export const getOwnState = (state) => state.etaModels;

//Information
export const getDestination = (state, userName): types.EtaDestination =>
  getOwnState(state).byId[userName];

export const getDestinationsList = (state): types.EtaDestination[] =>
  getOwnState(state).order.map((modelName) => getDestination(state, modelName));

// Selectores
export const isFetchingListDestinations = (state) => state.isFetchingList;
